import { api } from "../services/api.js";

document.addEventListener("DOMContentLoaded", () => {
    const jobDetailsContainer = document.getElementById("jd-content");
    if (!jobDetailsContainer) return;

    function resolveJobId() {
        // 1. Check query params (e.g. ?id=CS-00001 or ?jobId=CS-00001)
        const urlParams = new URLSearchParams(window.location.search);
        let id = urlParams.get('id') || urlParams.get('jobId') || urlParams.get('job_id');
        if (id) {
            try { sessionStorage.setItem('selectedJobId', id); } catch (e) {}
            return id;
        }

        // 2. Check path segment (e.g. /job-details/CS-00001) as fallback
        const segments = window.location.pathname.split('/').filter(Boolean);
        const lastSegment = segments[segments.length - 1];
        if (lastSegment && !lastSegment.includes('.html') && lastSegment !== 'job-details' && lastSegment !== 'careers') {
            const pathId = decodeURIComponent(lastSegment);
            try { sessionStorage.setItem('selectedJobId', pathId); } catch (e) {}
            return pathId;
        }

        // 3. Check sessionStorage fallback in case server redirect stripped query params
        try {
            const stored = sessionStorage.getItem('selectedJobId');
            if (stored) {
                return stored;
            }
        } catch (e) {}

        return null;
    }

    const jobId = resolveJobId();

    const elTitle = document.getElementById("jd-title");
    const elId = document.getElementById("jd-id");
    const elBreadcrumb = document.getElementById("jd-breadcrumb");
    const elRole = document.getElementById("jd-role");
    const elLocation = document.getElementById("jd-location");
    const elDesc = document.getElementById("jd-description");
    const elSkills = document.getElementById("jd-skills");
    const elExp = document.getElementById("jd-experience");
    
    const cardEl = document.getElementById("jd-card");
    const loadingEl = document.getElementById("jd-loading");
    const errorEl = document.getElementById("jd-error");

    if (!jobId) {
        showError();
        return;
    }

    // Prevent double invocation
    if (jobDetailsContainer.dataset.fetching === "true") return;
    jobDetailsContainer.dataset.fetching = "true";

    api.get(`jobs/${encodeURIComponent(jobId)}`)
        .then(response => {
            let job = null;
            if (response && response.data && (response.data.jobRole || response.data.jobId)) {
                job = response.data;
            } else if (response && (response.jobRole || response.jobId)) {
                job = response;
            } else if (response && response.data && response.data.job) {
                job = response.data.job;
            }

            if (job) {
                renderJob(job);
            } else {
                showError();
            }
        })
        .catch(err => {
            console.error("Error fetching job details:", err);
            showError();
        });

    function renderJob(job) {
        loadingEl.style.display = 'none';
        cardEl.style.display = 'block';

        const roleText = job.jobRole || '';
        elTitle.textContent = roleText;
        elId.textContent = job.jobId ? `(${job.jobId})` : '';
        elBreadcrumb.textContent = roleText;
        elRole.textContent = roleText;
        
        if (roleText) {
            document.title = `${roleText} ${job.jobId ? '(' + job.jobId + ') ' : ''}– CognoSpace`;
        }

        elLocation.textContent = (job.location && Array.isArray(job.location)) ? job.location.join(", ") : (job.location || 'Not Specified');
        elDesc.innerHTML = `<p>${job.description || ''}</p>`;

        if (job.skillsRequired && Array.isArray(job.skillsRequired)) {
            elSkills.innerHTML = job.skillsRequired.map(skill => `<li>${skill}</li>`).join('');
        } else {
            elSkills.innerHTML = `<li>Not Specified</li>`;
        }

        if (job.experienceRequired && Array.isArray(job.experienceRequired)) {
            elExp.innerHTML = job.experienceRequired.map(exp => `<li>${exp}</li>`).join('');
        } else {
            elExp.innerHTML = `<li>Not Specified</li>`;
        }

        // Pre-fill modal values
        const hiddenJobId = document.getElementById('appJobId');
        if (hiddenJobId) {
            hiddenJobId.value = job.jobId || jobId;
        }
        const modalTitle = document.querySelector('#applyJobModal .modal-title .text-orange');
        if (modalTitle && roleText) {
            modalTitle.textContent = roleText;
        }

        // Setup apply buttons to populate modal
        document.querySelectorAll('.jd-apply-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                if (modalTitle && roleText) {
                    modalTitle.textContent = roleText;
                }
                if (hiddenJobId) {
                    hiddenJobId.value = job.jobId || jobId;
                }
            });
        });
    }

    function showError() {
        loadingEl.style.display = 'none';
        errorEl.style.display = 'block';
        elTitle.textContent = "Job Not Found";
        elBreadcrumb.textContent = "Error";
    }
});
